module.exports = __webpack_public_path__ + "static/media/recupero-crediti.be1ce886.jpg";